import React, { useEffect } from "react";
import { KendoDropdown } from "../../Kendo/kendo_dropdown";
import { KendoEditor } from "../../Kendo/kendo_editor";
import { baseURL, post } from "../../Util/axios_helper";
import { useDispatch, useSelector } from "react-redux";
import {
  getEmailTemplates,
  getTemplateDataFields,
  onSubjectChange,
  onTemplateChange,
  onClear,
  onCursorPositionChange,
  setEditorContent,
} from "./template_slice";
import {
  Button,
  ErrorMsg,
  GetFormData,
  GetFormDataById,
  InfoIcon,
  Loader,
  ValidateForm,
  checkAccess,
  sessionUser,
} from "../../Util/common";
import { useState } from "react";
import { KendoLoader } from "../../Kendo/kendo_loader";

export const TemplatePage = ({ selTab }) => {
  useEffect(() => {
    if (selTab == 1) {
      $("#email").addClass("active");
      return () => {
        $("#email").removeClass("active");
      };
    }
  }, [selTab]);
  const [Loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const {
    emailTemplates,
    templateFields,
    emailTemplatesLoaded,
    templateFieldsLoaded,
    selTemplate,
    clearTemplate,
    cursorPosition,
  } = useSelector((state) => state.emailTemplate);
  const [error, setError] = useState({});

  useEffect(() => {
    dispatch(getEmailTemplates());
    // dispatch(getTemplateDataFields("EMAIL"));
  }, []);

  useEffect(() => {
    if (selTemplate?.EmailTemplateId) {
      const selectedTemplate = emailTemplates.find(
        (template) => template.EmailTemplateId == selTemplate.EmailTemplateId
      );

      if (selectedTemplate) {
        const emailTypeMap = {
          "Double Function": "EMAIL_MULTI",
          "Rental Meridian Client": "MERIDIAN",
          "Rental Outside Client": "NON_MERIDIAN",
          "Decoration Meridian Client": "MERIDIAN",
          "Decoration Outside Client": "NON_MERIDIAN",
        };

        const emailType =
          emailTypeMap[selectedTemplate.EmailTemplateName] || "EMAIL";

        // Re-dispatch actions to set the state properly
        dispatch(onTemplateChange(selTemplate.EmailTemplateId));
        dispatch(getTemplateDataFields(emailType));
      }
    }
  }, [emailTemplates, selTemplate?.EmailTemplateId]);

  useEffect(() => {}, [selTemplate, error]);

  const onDrag = (e) => {
    e.dataTransfer.setData("text/plain", `{${e.currentTarget.innerText}}`);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    var err = ValidateForm(e);
    if (err) {
      setError(err);
    } else {
      setLoading(true);
      let data = GetFormData(e);
      data.SavedBy = sessionUser();
      await post("EmailTemplate/UpdateEmailTemplate", data);
      dispatch(getEmailTemplates());
      setLoading(false);
    }
  };

  const onCancel = (e) => {
    dispatch(onClear());
    setError({});
  };

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const onSelection = (position) => {
    dispatch(onCursorPositionChange(position));
  };

  const onDataButtonClick = (e) => {
    let formData = GetFormDataById("form-email-template");
    if (formData) {
      let editorContent = formData.Body;
      let dataText = `{${e.currentTarget.innerText}}`;
      let updateContent =
        editorContent.slice(0, cursorPosition) +
        dataText +
        editorContent.slice(cursorPosition);
      dispatch(setEditorContent(updateContent));
    }
  };

  if (emailTemplatesLoaded && templateFieldsLoaded) {
    return <Loader />;
  }

  return (
    <form id="form-email-template" onSubmit={onSubmit}>
      <div className="row">
        {/* Template */}
        <div className="col-md-9">
          <div className="form-group">
            <label className="form-label">Template</label>
            <KendoDropdown
              name={"EmailTemplateId"}
              data={emailTemplates}
              dataTextField={"EmailTemplateName"}
              dataValueField={"EmailTemplateId"}
              value={selTemplate?.EmailTemplateId}
              required={true}
              onValidate={onValidation}
              onChange={(val) => {
                setError({});

                // Find the selected template based on ID
                const selectedTemplate = emailTemplates.find(
                  (template) => template.EmailTemplateId == val
                );

                if (selectedTemplate) {
                  const emailTypeMap = {
                    "Double Function": "EMAIL_MULTI",
                    "Rental Meridian Client": "MERIDIAN",
                    "Rental Outside Client": "NON_MERIDIAN",
                    "Decoration Meridian Client": "MERIDIAN",
                    "Decoration Outside Client": "NON_MERIDIAN",
                  };

                  // Check selected template name and get type
                  const emailType =
                    emailTypeMap[selectedTemplate.EmailTemplateName] || "EMAIL";

                  console.log(
                    "Selected Template:",
                    selectedTemplate.EmailTemplateName
                  );
                  console.log("Selected Email Type:", emailType);

                  // Dispatch actions
                  dispatch(onTemplateChange(val));
                  setTimeout(() => {
                    dispatch(getTemplateDataFields(emailType));
                  }, 0);
                } else {
                  console.warn("Template not found for ID:", val);
                }
              }}
            />
          </div>
        </div>
        {/* Save Button */}
        {(checkAccess("EMAILCONFIGCREATE") || checkAccess("EMAILCONFIGEDIT")) &&
          (Loading ? (
            <KendoLoader className="d-flex justify-content-end align-items-center" />
          ) : (
            <div className="col-md-3 d-flex justify-content-end align-items-center">
              <Button name={"Clear"} isCancelButton={true} onClick={onCancel} />
              <Button name={"Save"} />
            </div>
          ))}
      </div>
      {selTemplate && selTemplate.EmailTemplateId != 3 ? (
        <div className="row">
          <div className="col-md-9">
            <div className="form-group">
              <label>
                Subject <span className="text-danger">*</span>
              </label>
              <textarea
                type="text"
                className="form-control field"
                name="Subject"
                value={(selTemplate && selTemplate.Subject) || ""}
                data-required={selTemplate && selTemplate.EmailTemplateId != 3}
                onChange={(e) => {
                  onValidation("Subject", e.target.value);
                  dispatch(onSubjectChange(e.target.value));
                }}
              />
              {error.Subject && <ErrorMsg text="Subject is required" />}
            </div>
          </div>
        </div>
      ) : (
        <input type="hidden" name="Subject"></input>
      )}

      <div className="row g-1">
        {/* kendo editor */}
        <div className="col-md-9">
          <label>
            Body <span className="text-danger">*</span>
            <InfoIcon content="Please don't change the color of the placeholder text." />
          </label>
          <KendoEditor
            name="Body"
            imageBrowser={{
              enable: true,
              read: baseURL + "EmailTemplate/GetImages",
              upload: baseURL + "EmailTemplate/UploadImage",
              delete: baseURL + "EmailTemplate/DeleteImage",
              image: baseURL + "EmailTemplate/GetImage?path={0}",
              thumbnail: baseURL + "EmailTemplate/GetThumbnail",
            }}
            height={"340px"}
            value={selTemplate && selTemplate.Body}
            required={true}
            onValidate={onValidation}
            onCursorPositionChange={onSelection}
            refreshWhen={clearTemplate}
          />
          {error.Body && <ErrorMsg text="Body is required" />}
        </div>
        {/* Data fields */}
        <div className="col-md-3">
          <div
            style={{
              border: "1px solid rgba(0,0,0,.08)",
              height: "340px",
              overflowY: "auto",
              marginTop: "23px",
            }}
          >
            {templateFields &&
              templateFields.map((e) => {
                return (
                  <span
                    key={e.TemplateDataFieldId}
                    className="k-button k-button-solid-base k-button-solid k-button-md k-rounded-md hide-on-narrow k-editor-datafields"
                    draggable="true"
                    onDragStart={onDrag}
                    // title={
                    //   e.DataFieldName === "ItemDetails" ? "Only for Body" : ""
                    // }
                  >
                    {e.DataFieldName}
                    {e.DataFieldName === "ItemDetails" && (
                      <InfoIcon content="Item Details are only applicable to the Body." />
                    )}
                  </span>
                );
              })}
          </div>
        </div>
      </div>
    </form>
  );
};
